import React from 'react';
import { useRecordContext } from 'react-admin';
import { Chip } from '@mui/material';


const DirectionField = () => {
    const record = useRecordContext();

    if (!record?.direction) {
        return null;
    }

    const isInbound = record.direction === 'inbound'
    return (
        <Chip
            label={isInbound ? 'IN' : 'OUT'}
            size="small"
            color={isInbound ? 'success' : 'warning'}
            variant="outlined"
        />
    );
};

export default DirectionField;
